import DiscoveryPage from '@/models/DiscoveryPage'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
    discoveryPageDetails: null,
  },

  mutations: {
    setDiscoveryPageList(state, discoveryPages) {
      each(discoveryPages, (discoveryPage) => {
        const exist = find(state.list, { id: discoveryPage.id })
        if (!exist) {
          state.list.push(new DiscoveryPage(discoveryPage))
        }
      })
    },

    clearDiscoveryPageList(state) {
      state.list = []
    },

    setDiscoveryPageListMeta(state, meta) {
      state.listMeta = meta
    },

    setDiscoveryPageDetails(state, discoveryPage) {
      if (discoveryPage instanceof DiscoveryPage) {
        state.discoveryPageDetails = discoveryPage
      } else {
        state.discoveryPageDetails = new DiscoveryPage(discoveryPage)
      }
    },

    clearDiscoveryPageDetails(state) {
      state.discoveryPageDetails = null
    },

    clearDiscoveryPageAttachment(state) {
      state.discoveryPageDetails.attachment = null
    },
  },

  actions: {
    async getDiscoveryPages({ commit }, params) {
      const query = DiscoveryPage.page(params.page || 1)
        .include(['discovery', 'tags', 'coverPhoto', 'attachment'])
        .orderBy(params.sort)
      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.params({ limit: 20 }).get()
      commit('setDiscoveryPageList', res.data)
      commit('setDiscoveryPageListMeta', res.meta)
    },

    async getDiscoveryPageDetails({ commit }, id) {
      const { data } = await Api.get(`admin/discoveries/pages/${id}`)
      commit('setDiscoveryPageDetails', data.data)
    },

    async createDiscoveryPage({ commit }, formData) {
      const { data } = await Api.post(`admin/discoveries/pages`, formData)
      commit('setDiscoveryPageDetails', data.data)
    },

    async updateDiscoveryPage({ commit }, formData) {
      const { data } = await Api.post(
        `admin/discoveries/pages/${formData.get('id')}?_method=PUT`,
        formData
      )
      commit('setDiscoveryPageDetails', data.data)
    },

    async deleteDiscoveryPage({ commit }, id) {
      await Api.delete(`admin/discoveries/pages/${id}`)
      commit('clearDiscoveryPageDetails', id)
    },

    async deleteDiscoveryPageAttachment({ commit }, id) {
      await Api.delete(`admin/discoveries/pages/${id}/attachment`)
      commit('clearDiscoveryPageAttachment', id)
    },

    async exportToExcel({ commit }, params) {
      let endpoint = params.search
        ? `admin/discoveries/pages/export/${params.search}`
        : `admin/discoveries/pages/export`
      const file = await Api.get(endpoint, {
        responseType: 'blob',
      })
      return file
    },
  },
}
